import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import href from '#utilities/js/ea/href.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import blur from '@mailobj-browser/front/js/events/types/blur.js'
import focus from '@mailobj-browser/front/js/events/types/focus.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements, modifiers } from '../../../styles.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { get } from '#utilities/js/ea/ajax.js'

const onBlur = object(listener, {
  type: blur,
  hooks: array([
    preventDefault
  ]),
  task: async (
    textarea,
    { relatedTarget }
  ) => {
    const { ownerDocument, name } = textarea
    const draggableButton = one('button.ea_space__fridge_magnet_action[name="draggable"]', ownerDocument)

    if (relatedTarget === draggableButton) {
      return
    }

    const uid = name.split('_')[2]
    const container = one(`.${elements.fridge_container}`, ownerDocument)
    const { dataset } = container
    const { space, fridge } = dataset
    const li = closest(`.${elements.fridge_magnet}`, textarea)

    li.classList.remove(modifiers.fridge_memo.focus)

    const url = href('space/req_fridge', {
      act: 'modify_txt',
      magnet_text: textarea.value,
      uid,
      space,
      fridge
    })
    await get(url, { target: textarea })
  }
})

const onFocus = object(listener, {
  type: focus,
  hooks: array([
    preventDefault
  ]),
  task: textarea => {
    const li = closest(`.${elements.fridge_magnet}`, textarea)

    li.classList.add(modifiers.fridge_memo.focus)
  }
})

export default textarea => {
  onBlur.listen(textarea)
  onFocus.listen(textarea)
}
